import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import moment from 'moment-timezone';

import { FormattedRelative } from 'decisiv-domain-utils';
import { userTimeZone } from 'utils/timeUtils';
import { getOutputText } from 'utils/widget';

import Wrapper from './Wrapper';
import FollowUpValue from './FollowUpValue';

function FollowUpLabel({ followUpColor, followUpTime }) {
  const timeLabel = followUpTime &&
    <FormattedRelative
      render={relativeTime => <span>{relativeTime}</span>}
      value={moment.tz(followUpTime, userTimeZone())}
    />;

  return (
    <Wrapper color={followUpColor}>
      <FontAwesome name="flag" />
      <FollowUpValue>
        {getOutputText(timeLabel)}
      </FollowUpValue>
    </Wrapper>
  );
}

FollowUpLabel.propTypes = {
  followUpColor: PropTypes.string,
  followUpTime: PropTypes.string,
};

FollowUpLabel.defaultProps = {
  followUpColor: '',
  followUpTime: '',
};

export default FollowUpLabel;



// WEBPACK FOOTER //
// ./components/_common/FollowUpLabel/index.js